import { createSlice } from "@reduxjs/toolkit";

const NavbarBussinessSlice = createSlice({
  name: "navbarBussiness",
  initialState: {
    subMenuBussiness: [
      {
        id: 1,
        title: "",
        path: "/dashboard/business/detail/",
        hasSubNav: false,
        subNav: [],
      },
      {
        id: 2,
        title: "درگاه‌ها",
        path: "/dashboard/gatewayslist",
        hasSubNav: true,
        subNav: [
          {
            id: 1,
            title: "درگاه جدید",
            path: "/dashboard/newgateway",
            icon: "addicon",
          },
        ],
      },
      {
        id: 3,
        title: "فرم‌ها",
        path: "/dashboard/formslist",
        hasSubNav: true,
        subNav: [
          {
            id: 1,
            title: "فرم جدید",
            path: "/dashboard/newform",
            icon: "addicon",
          },
        ],
      },
      {
        id: 4,
        title: "تراکنش‌ها‌",
        path: "/dashboard/transactions",

        hasSubNav: false,
        subNav: [],
      },
      {
        id: 5,
        title: "تسویه‌ها",
        path: "/dashboard/settlement",

        hasSubNav: true,
        subNav: [
          {
            id: 1,
            title: "تسویه جدید",
            path: "/dashboard/newsettlment",
            icon: "addicon",
          },
        ],
      },
      // {
      //   id: 6,
      //   title: "تنظیمات",
      //   path: "/dashboard/setting",

      //   hasSubNav: false,
      //   subNav: []
      // }
    ],
  },

  reducers: {
    callNavbarBussiness: (state, action) => {
      state.subMenuBussiness[0].title = action.payload.subMenuBussiness;
      //  ////console.log("payload" ,  action.payload );

      // ////console.log("payload" ,  action.payload );
    },
    callNavbarSubPort: (state, action) => {
      // ////console.log("payload port" ,  action.payload );
      const AccountsArray = [];
      state.subMenuBussiness[1].subNav.splice(0);
      AccountsArray.push({
        id: 1,
        title: "درگاه جدید",
        path: "/dashboard/newgateway",
        icon: "addicon",
      });

      // for (let index = 0; index < action.payload.portData.length; index++) {
      //   let title= action.payload.portData[index].gateway.website_fa
      //   let id=action.payload.portData[index].gateway.id
      //   AccountsArray.push({
      //     id: id,
      //     title: title,
      //     path: `/dashboard/gateways/${id}`,
      //   icon: "porticon"
      //   },)

      // }

      state.subMenuBussiness[1].subNav = [...state.subMenuBussiness[1].subNav, ...AccountsArray];
      // ////console.log(AccountsArray, "<<<<<<<<<<<AccountsArray>>>>>>>>>");
    },
    callNavbarSubForm: (state, action) => {
      // ////console.log("payload form" ,  action.payload );
      const AccountsArray = [];
      state.subMenuBussiness[2].subNav.splice(0);
      AccountsArray.push({
        id: 1,
        title: "فرم جدید",
        path: "/dashboard/newform",
        icon: "addicon",
      });
      // for (let index = 0; index < action.payload.formData.length; index++) {
      //   let title= action.payload.formData[index].form.name
      //   let id=action.payload.formData[index].form.id
      //   AccountsArray.push({
      //     id: id,
      //     title: title,
      //     path: `/dashboard/forms/${id}/`,
      //   icon: "formicon"
      //   },)

      // }

      state.subMenuBussiness[2].subNav = [...state.subMenuBussiness[2].subNav, ...AccountsArray];
      //  ////console.log("payload" ,  action.payload );
    },
  },
});

export const { callNavbarBussiness, callNavbarSubPort, callNavbarSubForm } = NavbarBussinessSlice.actions;
export default NavbarBussinessSlice.reducer;
